module.exports = __webpack_public_path__ + "img/80392677b7ea638ed80432063c95807a.png";